import { Autoplay, FreeMode, Pagination } from 'swiper/modules';
import { Swiper, type SwiperProps, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import { useIsMobile } from '@/lib/is-mobile';

interface FreeModeProps extends Omit<SwiperProps, 'children'> {
  slidesView?: number;
  enableSingMode?: boolean;
  children: React.ReactNode;
}

export default function FreeModeSwiper({
  enableSingMode = false,
  slidesView,
  children,
  ...props
}: FreeModeProps) {
  const isMobile = useIsMobile();
  if (enableSingMode) {
    return (
      <Swiper
        style={{
          // @ts-expect-error -- custom css variables
          '--swiper-pagination-color': '#FF652C',
          '--swiper-pagination-bottom': '0px',
          overflow: 'hidden',
          paddingBottom: 24,
          width: '100%',
          justifyContent: 'left',
          justifyItems: 'left',
          position: 'relative',
          background: 'white',
        }}
        slidesPerView={slidesView && !isMobile ? slidesView : 1}
        centeredSlides={slidesView && !isMobile ? false : true}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Pagination]}
        {...props}
      >
        {children}
      </Swiper>
    );
  }

  return (
    <Swiper
      freeMode={true}
      modules={[FreeMode]}
      slidesPerView={slidesView ?? 'auto'}
      {...props}
    >
      {children}
    </Swiper>
  );
}

FreeModeSwiper.Slide = SwiperSlide;
